export class HighlightText {
    public static highlightSearchText = (searchText: string, containerClass: string) => {
        const mainContents = document.getElementsByClassName(containerClass);
        if (!mainContents.length) return;

        Array.from(mainContents).forEach(mainContent => {
            const elements = mainContent.querySelectorAll('*');
            elements.forEach(element => {
                if (element.childNodes.length === 1 && element.childNodes[0].nodeType === Node.TEXT_NODE) {
                    const text = element.textContent || '';
                    const regex = new RegExp(`(${searchText})`, 'gi');
                    const highlightedText = text.replace(regex, '<span style="color: var(--foreground-color); background-color: var(--primary-color);">$1</span>');
                    element.innerHTML = highlightedText;
                } else {
                    element.childNodes.forEach(child => {
                        if (child.nodeType === Node.TEXT_NODE) {
                            const text = child.textContent || '';
                            const regex = new RegExp(`(${searchText})`, 'gi');
                            const highlightedText = text.replace(regex, '<span style="color: var(--foreground-color); background-color: var(--primary-color);">$1</span>');
                            const span = document.createElement('span');
                            span.innerHTML = highlightedText;
                            element.replaceChild(span, child);
                        }
                    });
                }
            });
        });
    }

    public static removeHighlight = (containerClass: string) => {
        const mainContents = document.getElementsByClassName(containerClass);
        if (!mainContents.length) return;

        Array.from(mainContents).forEach(mainContent => {
            const highlightedElements = mainContent.querySelectorAll('span[style*="background-color: var(--primary-color);"]');
            highlightedElements.forEach(element => {
                const parent = element.parentNode;
                if (parent) {
                    parent.replaceChild(document.createTextNode(element.textContent || ''), element);
                    parent.normalize();
                }
            });
        });
    }
}